import { useLocalization } from "@progress/kendo-react-intl";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { ListView, ListViewFooter, ListViewHeader, ListViewItemProps } from "@progress/kendo-react-listview";
import { SvgIcon } from "@progress/kendo-react-common";
import { Avatar } from "@progress/kendo-react-layout";
import { arrowRotateCwIcon, plusIcon, saveIcon, searchIcon, starIcon, trashIcon } from "@progress/kendo-svg-icons";
import { TextBox, TextBoxChangeEvent, TextBoxProps } from "@progress/kendo-react-inputs";
import { Dialog } from "@progress/kendo-react-dialogs";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { Button } from "@progress/kendo-react-buttons";
import { useLocation } from "react-router-dom";
import { loadingPanel } from "../../LoadingPanel";


/**
 * ConfigDevicesManagement is a component responsible for managing the configuration
 * of devices. It interacts with an API to fetch and manipulate device data, including
 * adding, updating, and disabling devices. The component maintains various states
 * for managing device lists, selected device details, loading states, and notifications.
 * It also utilizes localization services for displaying language-specific strings.
 */

export const ConfigDevicesManagement = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const [devicesList, setDevicesList] = useState<any>(null);
    const [counterActiveDevices, setCounterActiveDevices] = useState(null);
    const [counterInactiveDevices, setCounterInactiveDevices] = useState(null);
    const [deviceToDisable, setDeviceToDisable] = useState<any>(null);
    const [deviceMacSelected, setDeviceMacSelected] = useState('');
    const [deviceTypeName, setDeviceTypeName] = useState('');
    const [deviceNameSelected, setDeviceNameSelected] = useState<TextBoxProps["value"]>('');
    const [deviceVersionSelected, setDeviceVersionSelected] = useState<TextBoxProps["value"]>('');

    const [batterySelected, setBatterySelected] = useState('');
    const [lastCommunicationTimeSelected, setLastCommunicationTimeSelected] = useState<any>('');
    const [mapIdSelected, setMapIdSelected] = useState<any>('');

    const [listViewData, setListViewData] = useState(devicesList);
    const [groupsList, setGroupsList] = useState<any>([]);
    const [groupNameSelected, setGroupNameSelected] = useState<any>(null);
    const [groupIdSelected, setGroupIdSelected] = useState<any>(null);

    const [jobsList, setJobsList] = useState<any>(null);
    const [jobSelected, setJobSelected] = useState<any>(null);
    const [jobIdSelected, setJobIdSelected] = useState<any>(null);
    const [jobsListName, setJobsListName] = useState<any>(null);

    const [messageDisabledDevice, setMessageDisabledDevice] = useState<boolean>(false);
    const [showPopupDeletedDevice, setShowPopupDeletedDevice] = useState<boolean>(false);

    const [messageAddedDevice, setMessageAddedDevice] = useState<boolean>(false);
    const [messageSavedDevice, setMessageSavedDevice] = useState<boolean>(false);

    const [error, setError] = useState('');

    const [showPopupAddDevice, setShowPopupAddDevice] = useState<boolean>(false);
    const [newDeviceMac, setNewDeviceMac] = useState<string>('');


    const localizationService = useLocalization();

    const [instance, accessTokenRequest] = AccessToken();

    let languageId = localStorage.getItem('languageId');

    const [loading, setLoading] = useState(false);

    const location = useLocation();
    // get deviceMac from synoptic grid devices
    let deviceMac = location?.state?.deviceMac;

    const getDeviceList = async (flag: boolean) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/device/active`, {
                headers,
                params: {
                    enabled: flag
                }
            })
            .then((res:any) => {
                if(res.length == 0) return;
                    
                const data: any = res?.data
                if (flag) {
                    setCounterActiveDevices(data?.data?.length);
                    setDevicesList(data?.data);
                } else {
                    setCounterInactiveDevices(data?.data?.length);
                }
                setLoading(false);
            }).catch((data) => {
                setError(data?.message);
            });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    //  call API on page load
    useEffect(() => {
        getDeviceList(true)
        //getDeviceList(false)
    }, [])

    const onFilterChange = (ev: any) => {
        let value = ev.value;
        let newData = devicesList.filter((device: any) => {
            let match = false;
            for (const property in device) {

                if ((device['name']?.toString() && device['name']?.toString().toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0) || (device['mac']?.toString() && device['mac']?.toString().toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0) )
                {
                    match = true;
                }
            }
            return match;
        });
        setListViewData(newData);
    };

    const MyHeader = () => {
        return (
            <>
                <ListViewHeader
                    style={{ color: "#018CA5", fontSize: 14 }}
                    className="pl-3 pb-2 pt-2"
                >
                    {localizationService.toLanguageString('configuration.devices.devices_list', 'NOT FOUND')} ({counterActiveDevices} {localizationService.toLanguageString('configuration.devices.active_devices', 'NOT_FOUND')})
                </ListViewHeader>
            </>
        );
    };

    const MyFooter = () => {
        let messages = 0;
        devicesList.map((i: any) => {
            messages = messages + i.messages;
        });
        return (
            <ListViewFooter
                style={{ color: "#018CA5", fontSize: 14 }}
                className="pl-3 pb-2 pt-2"
            >
                {/*{counterActiveDevices} {localizationService.toLanguageString('configuration.devices.active_devices', 'NOT_FOUND')}*/}
            </ListViewFooter>
        );
    };

    const toggleDialog = (item?: any) => {
        setDeviceToDisable(item);
        setShowPopupDeletedDevice(!showPopupDeletedDevice);
    };

    const disableDevice = async () => {

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}` };
            axios.delete(`${SERVER_URL}/device/${deviceToDisable.mac}`, { headers })
                .then(() => {
                    getDeviceList(true)
                    setDeviceMacSelected('');
                    setMessageDisabledDevice(true);
                    if (!messageAddedDevice) {
                        setTimeout(() => {
                            setMessageDisabledDevice(false);
                        }, 3000);
                    }
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        onToggleMessage()
    }

    // called on click device
    const getDeviceMacSelected = (device: any) => {
        setDeviceMacSelected(device.mac);
        setDeviceNameSelected(device.name);
        setDeviceTypeName(device.deviceTypeName);
        setDeviceVersionSelected(device.version);
        setGroupNameSelected(device.groupName);
        setGroupIdSelected(device.groupId);

        setBatterySelected(device.battery);
        setLastCommunicationTimeSelected(device.lastCommunicationTime);
        setMapIdSelected(device.mapId);

        getGroupList();
        //getJobsByDeviceMac(device.mac, true);        

        getJobsByGroup(device.groupId);
    }

    const DevicesRender = (props: ListViewItemProps) => {
        let device = props.dataItem;
        return (
            <div
                className="k-listview-item row p-2 border-bottom align-middle"
                style={{ margin: 0 }}
            >
                <div
                    className="col-2"
                    style={{ alignContent: 'center' }}
                    onClick={() => { toggleDialog(device) }}
                >
                    <Avatar
                        type="img"
                        style={{ cursor: 'pointer' }}
                        className="trash-icon"
                    >
                        <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                    </Avatar>
                </div>
                <div
                    className="col-9"
                    style={{ cursor: 'pointer', color: "#018CA5", }}
                    onClick={() => { getDeviceMacSelected(device) }}
                >
                    <h2
                        className="device-management-name-h2"
                        style={{
                            fontSize: 16,
                            cursor: 'pointer',
                            padding: '10px',
                            //textTransform: 'uppercase'

                        }}
                    >
                        {device.name} ({device.mac})
                    </h2>
                </div>
            </div>
        );
    };

    const handleChangeDeviceName = useCallback((event: TextBoxChangeEvent) => {
        setDeviceNameSelected(event.target.value);
    }, []);

    const handleChangeDeviceVersion = useCallback((event: TextBoxChangeEvent) => {
        setDeviceVersionSelected(event.target.value);
    }, []);

    const getGroupList = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/list?enabled=true`, { headers })
                .then((res) => {
                    const data = res.data.data

                    // add no group to the list
                    data.unshift({
                        id: '-1',
                        name: localizationService.toLanguageString('configuration.devices.no_group', 'NOT_FOUND')
                    })

                    setGroupsList(data);

                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getDeviceDetailsFromSynoptic = async (deviceMac: any) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/device/active`, {
                headers
            })
            .then((res) => {
                const data: any = res?.data.data
                //setCounterActiveDevices(data?.data?.length);
                //setDevicesList(data?.data);

                const currentDevice = data.filter((device:any) => device?.mac === deviceMac);
                setDeviceMacSelected(currentDevice[0].mac);
                setDeviceNameSelected(currentDevice[0].name);
                setDeviceTypeName(currentDevice[0].deviceTypeName);
                setDeviceVersionSelected(currentDevice[0].version);
                setGroupNameSelected(currentDevice[0].groupName);
                setGroupIdSelected(currentDevice[0].groupId);
                setBatterySelected(currentDevice[0].battery);
                setLastCommunicationTimeSelected(currentDevice[0].lastCommunicationTime);
                setMapIdSelected(currentDevice[0].mapId);
                
                getGroupList();
                
                getJobsByGroup(currentDevice[0].groupId);      
                setLoading(false);         
            }).catch((data) => {
                setError(data?.message);
                setLoading(false);
            });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }                
    }

    useEffect(() => {
        getDeviceDetailsFromSynoptic(deviceMac);
    },[deviceMac])

    useEffect(() => {
        getJobList(true);
    }, []);

    const getJobList = async (flag: boolean) => {

        setLoading(true);
        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/job/list?enabled=${flag}`, { headers })
                .then((res) => {
                    const data = res?.data?.data

                    let jobList: any = []
                    data.forEach((job: any) => {
                        jobList.push(job)
                    });
                    setJobsList(jobList);
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    };

    const getJobsByDeviceMac = async (mac: any, active: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/Device/${mac}/job/${active}/list`, { headers })
                .then((res) => {
                    const data = res.data.data

                    let jobsList: any = []

                    jobsList.forEach((job: any) => {
                        if (data.find((e: any) => e.jobId === job.id)) {
                            jobsList.push({ id: job.id, name: job.name })
                        }
                    });

                    // add no group to the list
                    jobsList.unshift({
                        id: '-1',
                        name: localizationService.toLanguageString('configuration.devices.no_job', 'NOT_FOUND')
                    })

                    setJobsListName(jobsList)
                    if (jobsList.length > 0) {
                        setJobSelected(jobsList[0].name)
                    } else {
                        setJobSelected(null)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getJobsByGroup = async (groupId: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/${groupId}/jobs`, { headers })
                .then((res) => {
                    const data = res.data.data
                    setJobSelected([])
                    data.unshift({ id: -1, name: localizationService.toLanguageString('configuration.devices.no_job', 'NOT_FOUND') })

                    setJobsListName(data)
                    if (data.length > 0) {
                        setJobSelected(data[0].name)
                        setJobIdSelected(data[0].id)
                    } else {
                        setJobSelected(null)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const handleChangeGroup = useCallback((event: any, groupsList: any) => {
        const currentGroup = groupsList.find((group: any) => group.name === event.target.value);
        setGroupNameSelected(currentGroup.name);
        setGroupIdSelected(currentGroup.id);
        getJobsByGroup(currentGroup.id);
    }, [])


    const handleChangeJob = useCallback((event: DropDownListChangeEvent, jobsListName: any) => {
        setJobSelected(event.target.value);
        jobsListName.forEach((job: any) => {
            if (job.name === event.target.value) {
                setJobIdSelected(job.id)
            }
        })
    }, [])

    const CustomTitle = () => {
        return (
            <div
                className="custom-title"
                style={{ fontSize: "18px", lineHeight: "1.3em" }}
            >
                {localizationService.toLanguageString('configuration.devices.disable_device', 'NOT FOUND')} "{deviceToDisable.name} ({deviceToDisable.mac})" ?
            </div>
        );
    };

    const onToggleMessage = () => {
        setMessageDisabledDevice(true);
        if (!messageDisabledDevice) {
            setTimeout(() => {
                setMessageDisabledDevice(false);
            }, 3000);
        }
    };

    const openPopupAddDevice = () => {
        setShowPopupAddDevice(!showPopupAddDevice);
    }

    const addDevice = async () => {

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}` };
            axios.post(`${SERVER_URL}/device/${newDeviceMac}`, null, { headers })
                .then(() => {
                    setMessageAddedDevice(true);
                    getDeviceList(true)
                    getGroupList()
                    setDeviceMacSelected(newDeviceMac)
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (!messageAddedDevice) {
            setTimeout(() => {
                setMessageAddedDevice(false);
            }, 3000);
        }

    }

    const updateDevice = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                name: deviceNameSelected,
                version: deviceVersionSelected,
                groupId: groupIdSelected
            }
            try {
                await axios.put(`${SERVER_URL}/device/${deviceMacSelected}`, params, { headers })
                assignJobToDevice();   
                setLoading(false);       
            } catch (error: any) {
                setError(error);
                setLoading(false);
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }

    }

    const assignJobToDevice = async () => {

        setLoading(true);

        const params = {
            mac: deviceMacSelected ?? newDeviceMac,
            jobId: jobIdSelected ?? -1
        }

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            try {
                await axios.post(`${SERVER_URL}/device/job/assign`, params, { headers })
                setMessageSavedDevice(true);
                getDeviceList(true)
                setLoading(false);
            } catch (error: any) {
                setError(error);
                setLoading(false);
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }       

        if (!messageSavedDevice) {
            setTimeout(() => {
                setMessageSavedDevice(false);
            }, 3000);
        }

    }

    return (
        <>
            {loading && loadingPanel}
            {devicesList?.length == 0 &&
            // Mostra un messaggio o un altro contenuto se non ci sono dati
            <div style={{ textAlign: 'center', padding: '20px', border: '1px dashed #ccc' }}>
                <p>{localizationService.toLanguageString('configuration.devices.no_data', 'NOT_FOUND')}</p>
            </div>
            }
            {devicesList?.length > 0 &&
                <div className={deviceMacSelected && "flex-parent-element"} >

                    <NotificationGroup
                        style={{
                            right: 0,
                            bottom: 50,
                            alignItems: "flex-start",
                            flexWrap: "wrap-reverse",
                        }}
                    >
                        <Fade enter={true} exit={true}>
                            {messageDisabledDevice && (
                                <Notification
                                    type={{ style: "success", icon: true }}
                                    closable={true}
                                    onClose={() => setMessageDisabledDevice(false)}
                                >
                                    <span>{localizationService.toLanguageString('configuration.devices.device_delete', 'NOT FOUND')}</span>
                                </Notification>
                            )}
                            {messageAddedDevice && (
                                <Notification
                                    type={{ style: "success", icon: true }}
                                    closable={true}
                                    onClose={() => setMessageAddedDevice(false)}
                                >
                                    <span>{localizationService.toLanguageString('configuration.devices.added_device', 'NOT FOUND')}</span>
                                </Notification>
                            )}
                            {messageSavedDevice && (
                                <Notification
                                    type={{ style: "success", icon: true }}
                                    closable={true}
                                    onClose={() => setMessageSavedDevice(false)}
                                >
                                    <span>{localizationService.toLanguageString('configuration.devices.saved_device', 'NOT FOUND')}</span>
                                </Notification>
                            )}
                        </Fade>
                    </NotificationGroup>

                    {/* left panel */}
                    <div
                        className="flex-left-child-element"
                        style={{ width: "42%", background: "#F7F7F7", paddingLeft: "5%" }}
                    >
                        {loading && loadingPanel}
                        <div
                            className="k-listview-item row p-2 align-middle"
                            style={{ display: 'block', margin: 0 }}
                        >
                            <fieldset style={{ display: 'flex' }} >
                                {/*{localizationService.toLanguageString('search', 'NOT FOUND')}:*/}
                                <TextBox
                                    style={{
                                        border: '2px solid #ccc',
                                        boxShadow: 'inset 0px 0px 5px 0px rgba(0,0,0,0.13)',
                                        marginBottom: '10px',
                                    }}
                                    onChange={onFilterChange}
                                    placeholder={localizationService.toLanguageString('configuration.devices.search_device', 'NOT FOUND')}
                                    prefix={() => (
                                        <SvgIcon icon={searchIcon} svgStyle={{ margin: '20px -5px 0px 5px' }} />
                                    )}
                                />

                                {/* refresh device list button */}
                                <Button
                                    className="plusParam"
                                    style={{ marginTop: '0px' }}
                                    onClick={() => { getDeviceList(true) }}
                                    title={localizationService.toLanguageString('configuration.devices.refresh_list', 'NOT FOUND')}
                                >
                                    <Avatar
                                        className="plusParam"
                                    >
                                        <SvgIcon icon={arrowRotateCwIcon} style={{ margin: '8px' }} />
                                    </Avatar>
                                </Button>

                                {/* add device button */}
                                <Button
                                    themeColor={"primary"}
                                    className="plusParam"
                                    onClick={() => { openPopupAddDevice() }}
                                    style={{ marginTop: '0px' }}
                                    title={localizationService.toLanguageString('configuration.devices.add_device', 'NOT FOUND')}
                                >
                                    <Avatar
                                        className="plusParam"
                                    >
                                        <SvgIcon
                                            icon={plusIcon}
                                            style={{
                                                margin: '8px'
                                            }}
                                        />
                                    </Avatar>
                                </Button>
                            </fieldset>
                        </div>

                        <ListView
                            data={listViewData ?? devicesList}
                            item={DevicesRender}
                            style={{ background: "#F7F7F7", height: '90%' }}
                            header={MyHeader}
                            footer={MyFooter}
                        //onScroll={scrollHandler}
                        />
                        {showPopupAddDevice && (
                            <Dialog
                                title={localizationService.toLanguageString('configuration.devices.add_device', 'NOT FOUND')}
                                onClose={openPopupAddDevice}
                                contentStyle= {{ color: 'black' }}
                                //className="k-dialog-titlebar-devices-management"
                            >
                                <TextBox
                                    style={{
                                        boxShadow: 'inset 0px 0px 5px 0px rgba(0,0,0,0.13)',
                                        marginBottom: '10px',
                                    }}
                                    onChange={(e: any) => setNewDeviceMac(e.target.value)}
                                    placeholder={localizationService.toLanguageString('configuration.devices.mac', 'NOT FOUND')}
                                />
                                <div className='k-window-content k-buttons-container' >
                                    <button
                                        className="add-device-button"
                                        onClick={openPopupAddDevice}
                                    >
                                        {localizationService.toLanguageString('no', 'NOT FOUND')}
                                    </button>
                                    <button
                                        className="add-device-button"
                                        onClick={() => {
                                            if (!showPopupDeletedDevice) {
                                                openPopupAddDevice()
                                                addDevice()
                                            }
                                        }}
                                    >
                                        {localizationService.toLanguageString('yes', 'NOT FOUND')}
                                    </button>
                                </div>
                            </Dialog>
                        )}
                        {showPopupDeletedDevice && (
                            <Dialog
                                //title={localizationService.toLanguageString('configuration.devices.disable_device', 'NOT FOUND')}
                                title={<CustomTitle />}
                                onClose={toggleDialog}
                            >
                                <div>
                                    <button
                                        className="disable-device-button"                                        
                                        onClick={toggleDialog}
                                    >
                                        {localizationService.toLanguageString('no', 'NOT FOUND')}
                                    </button>
                                    <button
                                        className="disable-device-button"
                                        onClick={() => {
                                            if (showPopupDeletedDevice) {
                                                toggleDialog()
                                                disableDevice()
                                            }
                                        }}
                                    >
                                        {localizationService.toLanguageString('yes', 'NOT FOUND')}
                                    </button>
                                </div>
                            </Dialog>
                        )}
                    </div>

                    {/* right panel */}
                    {deviceMacSelected != '' &&
                        //<div className="flex-right-child-element" style={{ width: "20%", background: '#ffffff' }}>
                        <div
                            style={{ margin: '0 auto', alignContent: 'center' }}
                        >
                            {/* mac + name */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <fieldset>
                                    <h1 className="k-h2" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.mac', 'NOT_FOUND')}</h1>
                                    <h5 className="k-h5" style={{ color: '#018CA5' }}>{deviceMacSelected != '' ? deviceMacSelected : localizationService.toLanguageString('configuration.devices.no_mac', 'NOT_FOUND')}</h5>

                                    <hr style={{ border: '1px solid #018CA5', width: '100%' }} />

                                    <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.name', 'NOT_FOUND')}</div>
                                    <TextBox
                                        value={deviceNameSelected != '' ? deviceNameSelected : ''}
                                        onChange={handleChangeDeviceName}
                                        placeholder={localizationService.toLanguageString('configuration.devices.enter_device_name', 'NOT_FOUND')}
                                    />
                                </fieldset>
                            </div>

                            <br />

                            {/* type */}
                            <div className="k-listview-item row p-1 align-middle">
                                <div className="col-2" >
                                    <Avatar type="img" style={{ background: "#018CA5" }}>
                                        <SvgIcon icon={starIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                    </Avatar>
                                </div>
                                <div className="col-9" >
                                    <h1
                                        style={{
                                            fontSize: 16,
                                            color: "#018CA5",
                                            verticalAlign: 'bottom',
                                            display: 'inline-flex'
                                        }}
                                        className="text-uppercase"
                                    >
                                        {deviceTypeName != '' ? deviceTypeName : ''}
                                    </h1>
                                </div>
                            </div>

                            <br />

                            {/* version */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <fieldset>
                                    <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.version', 'NOT_FOUND')}</div>
                                    <TextBox
                                        value={deviceVersionSelected != '' ? deviceVersionSelected : ''}
                                        onChange={handleChangeDeviceVersion}
                                        placeholder={localizationService.toLanguageString('configuration.devices.enter_device_version', 'NOT_FOUND')}
                                    />
                                </fieldset>
                            </div>

                            {/* serial Ip/Nfc */}
                            {/*<div
                                className="k-listview-item row p-2 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <fieldset>
                                    <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.serial', 'NOT_FOUND')}</div>
                                    <TextBox
                                        value={deviceIpSelected != '' ? deviceIpSelected : ''}
                                        onChange={handleChangeDeviceIp}
                                        placeholder={'Ip'}
                                    />

                                    <br />
                                    <br />

                                    <TextBox
                                        value={deviceNfcSelected != '' ? deviceNfcSelected : ''}
                                        onChange={handleChangeDeviceNfc}
                                        placeholder={'Nfc'}
                                    />
                                </fieldset>
                            </div>*/}

                            {/* groups */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <fieldset>
                                    <div className="k-h5" style={{ color: '#018CA5', marginTop: '10px' }}>{localizationService.toLanguageString('configuration.devices.groups', 'NOT_FOUND')}</div>
                                    <DropDownList
                                        data={groupsList?.map((group: any) => {
                                            return (
                                                group.name
                                            )
                                        })}
                                        value={groupNameSelected}
                                        onChange={(e: any) => handleChangeGroup(e, groupsList)}
                                        style={{ width: "100%", color: '#018CA5', cursor: 'pointer' }}
                                    />
                                </fieldset>
                            </div>

                            {/* jobs */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                { groupIdSelected != 0 && groupIdSelected != -1 &&
                                    <fieldset>
                                        <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.jobs', 'NOT_FOUND')}</div>
                                        <DropDownList
                                            data={jobsListName?.map((job: any) => {
                                                return (
                                                    job?.name ?? ''
                                                )
                                            })}
                                            value={jobSelected != '' ? jobSelected : ''}
                                            defaultValue={localizationService.toLanguageString('configuration.devices.select_job', 'NOT_FOUND')}
                                            onChange={(e: any) => handleChangeJob(e, jobsListName)}
                                            style={{ width: "100%", color: '#018CA5', cursor: 'pointer' }}
                                        //title={localizationService.toLanguageString('configuration.devices.select_job', 'NOT_FOUND')}
                                        />
                                    </fieldset>
                                }
                                
                                {/*  save button */}
                                <div className="k-listview-item row p-3">
                                    <Button
                                        className="save-devices-management-button"
                                        themeColor={"primary"}
                                        svgIcon={saveIcon}
                                        onClick={() => updateDevice()}
                                    >
                                        {localizationService.toLanguageString('configuration.devices.save', 'NOT_FOUND')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </>
    )
}